<template>
    <div class="the-page">
        <initial-metrics></initial-metrics>
        <header aria-label="Header">
            <spinner v-if="isLoading || isDownloading"></spinner>
            <cdc-logo></cdc-logo>
            <app-header :showFullApp="showFullApp"></app-header>
        </header>
        <main>
            <div class="container body-wrapper">
                <div id="content">
                    <div class="app-section">
                        <div class="leftnav-wrapper hide-on-print">
                            <navigation displayType="desktop"></navigation>
                        </div>
                        <div class="content-section">
                            <div class="hidden-xs">
                                <div
                                    v-if="splashDescription"
                                    class="splash-description"
                                >
                                    <p>{{ splashDescription }}</p>
                                </div>
                            </div>
                            <div class="hide-on-print">
                                <div
                                    v-if="environmentName === 'dev'"
                                    style="
                                        background-color: lightgreen;
                                        font-weight: bold;
                                    "
                                >
                                    Development
                                </div>
                                <div
                                    v-else-if="environmentName === 'qa'"
                                    style="
                                        background-color: yellow;
                                        font-weight: bold;
                                    "
                                >
                                    QA
                                </div>
                                <h2
                                    v-if="
                                        dataListsLoaded &&
                                        pageTitle &&
                                        pageTitle.length > 0
                                    "
                                >
                                    {{ pageTitle }}
                                </h2>
                                <h2 v-if="!pageTitle || pageTitle.length === 0">
                                    BRFSS WEAT
                                </h2>
                            </div>
                            <validation-summary></validation-summary>
                            <div class="the-page-2" id="weat">
                                <error-pop-up></error-pop-up>
                                <form id="weatForm" v-if="dataListsLoaded">
                                    <router-view
                                        :key="$route.fullPath"
                                    ></router-view>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <layout-footer></layout-footer>
    </div>
</template>
<script>
/* eslint spaced-comment: 'off' */
import common from '@/scripts/common';
import selectionUtility from '@/scripts/selectionUtility';
import { mapGetters, mapState } from 'vuex';
import appHeader from '@/components/layout/appHeader';
import errorPopUp from '@/components/errorPopUp';
import navigation from '@/components/layout/navigation';
import spinner from '@/components/sub/spinner';
import navMenuItems from '@/scripts/nav/menuItems';
import layoutFooter from '@/components/layout/layoutFooter';
import cdcLogo from '@/components/layout/cdcLogo';
import metricsHelper from '@/scripts/metricsHelper';
import validationSummary from '@/components/sub/validationSummary.vue';
import store from '@/store';
import initialMetrics from '@/components/initialMetrics';

export default {
    name: 'app',
    components: {
        navigation,
        appHeader,
        layoutFooter,
        spinner,
        cdcLogo,
        errorPopUp,
        validationSummary,
        initialMetrics
    },
    beforeCreate: function () {
        store.dispatch('dataLists/load');
    },
    computed: {
        ...mapState({
            splashDescription: (state) => state.display.splashDescription,
            pageTitle: (state) => state.display.pageTitle,
            showFullApp: (state) => true,
            isLoading: (state) => state.display.isLoading,
            isDownloading: (state) => state.display.isDownloading,
            dataListsLoaded: (state) => state.dataLists.allLoaded
        }),
        ...mapGetters({})
    },
    created: function () {
        let vm = this;
        window.weatProcessEnv = process.env;
        //console.log('process.env', process.env);
        //The template package needs a body to load or it gets an error.  Remove that, and add the new body
        // let oldBody = document.getElementById("body");
        // if (oldBody && oldBody.parentElement.id !== "bodyContainer")
        //   oldBody.parentElement.removeChild(oldBody);
        // window.theRefs = vm.$refs;
        // vm.$refs.body.id = 'body';
        // console.log('vm.$refs.body', vm.$refs.body);
        metricsHelper.test();
    },
    data: function () {
        //var vm = new Vue()
        //console.log(this.$myProperty)
        //Used to force reload on new version deployed.  This MUST match static\version.js
        navMenuItems.initialize();
        return {
            environmentName: process.env.APP_ENV
        };
    },
    methods: {}
};

//common.initialize();  //This loads any html files
selectionUtility.initialize();
</script>

<style>
/* @import './assets/styles/bootstrap-grid.css'; */
@import './assets/styles/themeGreen.css';
@import './assets/styles/brfssApp.css';
@import './assets/styles/bootstrap-glyphicons.min.css';
/* @import './assets/styles/forms.less.css'; */
/* @import './assets/styles/bootstrap-glyphicons.css'; */
/* TODO: re-enable this when we want to use container-fluid
#wrapper .container.mar_bot {
  width: 100%;
  max-width: 2100px;
  float: left;
}
*/
.not-available {
    margin-left: 10%;
    margin-bottom: 50px;
}

.not-available div:first-child {
    font-size: 24px;
}

.body-wrapper {
    padding-left: 0;
    padding-right: 0;
    padding-top: 1rem;
    background: #fff;
}
/* #content {

} */
body {
    margin: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    background-color: #f5f5f5;
    font-family: 'Open Sans', apple-system, blinkmacsystemfont, 'Segoe UI',
        'Helvetica Neue', arial, sans-serif;
    color: #000;
    font-size: 17px;
    border-top: 5px solid #bdbdbd;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

address {
    margin-bottom: 1rem;
    font-style: normal;
    line-height: inherit;
}

#wrapper {
    border-top: none;
}
#layoutFooter .container {
    width: 100%;
}
#hhs {
    margin-right: 20px;
}

@import './css/local.css';
/* @import './css/brfssApp.css'; */

/* #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
} */

#contentArea {
    padding: 0 0 0 0;
}

.hyperlink-button {
    background-color: transparent;
    border: none;
    text-decoration: underline;
    color: #075290;
    padding-left: 0px;
    font-size: 17px;
    margin-bottom: 5px;
    padding-top: 10px;
}

.hyperlink-button:hover {
    text-decoration: none;
}

.hyperlink-button {
    /*padding-left: 15px;*/
    text-align: right;
    padding-right: 15px;
    padding-left: 0px;
}

/*@media(max-width:767px) {
    .hyperlink-button {
      padding-top: 0px;
    }
  }*/
/* h4 {
  padding-top: 9px;
} */

@media screen {
    .show-only-on-print {
        display: none !important;
    }
}

@media print {
    .show-only-on-print {
        display: block !important;
    }

    .hide-on-print {
        display: none !important;
    }

    .page-break {
        page-break-before: always;
    }
}

/*From bootstrap 2.4*/
input[disabled],
select[disabled],
textarea[disabled],
input[readonly],
select[readonly],
textarea[readonly] {
    cursor: not-allowed;
    background-color: #eee;
}

select,
textarea,
input[type='text'],
input[type='password'],
input[type='datetime'],
input[type='datetime-local'],
input[type='date'],
input[type='month'],
input[type='time'],
input[type='week'],
input[type='number'],
input[type='email'],
input[type='url'],
input[type='search'],
input[type='tel'],
input[type='color'],
.uneditable-input {
    display: inline-block;
    height: 20px;
    padding: 4px 6px;
    /*margin-bottom: 10px;*/
    font-size: 14px;
    line-height: 20px;
    color: #555;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    vertical-align: middle;
}

select,
input[type='file'] {
    height: 30px;
    *margin-top: 4px;
    line-height: 30px;
}

.table th,
.table td {
    padding: 8px;
    line-height: 20px;
    text-align: left;
    vertical-align: top;
    border-top: 1px solid #ddd;
    font-size: 14px;
}

.table-bordered {
    border: 1px solid #ddd;
    border-collapse: separate;
    *border-collapse: collapse;
    border-left: 0;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
}

.table-bordered th,
.table-bordered td {
    border-left: 1px solid #ddd;
}
/*select, textarea, input[type="text"], input[type="password"], input[type="datetime"], input[type="datetime-local"], input[type="date"], input[type="month"], input[type="time"], input[type="week"], input[type="number"], input[type="email"], input[type="url"], input[type="search"], input[type="tel"], input[type="color"], .uneditable-input {
    display: inline-block;
    height: 20px;
    padding: 4px 6px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 20px;
    color: #555;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    vertical-align: middle
  }*/

.search-form-wrapper .search-input-wrapper button {
    height: 28px !important;
}

.the-page-2 {
    position: relative;
}
@media (max-width: 1199px) {
    .leftnav-wrapper {
        display: none;
    }

    content-section {
        width: 100%;
    }
}

@media (min-width: 1200px) {
    .app-section {
        display: flex;
    }
    .leftnav-wrapper {
        flex: 0 1 325px;
        /* max-width: 25%; */
        padding-right: 15px;
        padding-left: 15px;
        display: block;
        /* flex-grow: 0;
        flex-shrink: 0;
        flex-basis: 200px;
        margin-right: 20px; */
        /* width: 60%; */
        /* max-width: 325px; */
    }
    .content-section {
        margin: 0 15px;
        flex: 0 1 100%;
        overflow: auto;
    }
}
@media (min-width: 1200px) {
    /* .leftnav-wrapper {
    flex-basis: 200px;
  } */
    /* .content-section {
    width: 100%;
  } */
}

.accessibleHide,
td.active_label label,
legend.hidden-label label,
.hidden-input-label label {
    position: absolute;
    left: -10000px;
    top: auto;
    width: 1px;
    height: 1px;
    overflow: hidden;
}

.print-only {
    display: none;
}

@media print {
    .no-print {
        display: none;
    }

    .print-only {
        display: block;
    }
}

.tooltip-inner {
    white-space: pre-wrap;
    width: 500px !important;
}

.nav-related {
    margin-top: 10px;
}

.nav-related [class*='span'] {
    width: auto !important;
}

abbr.required-abbr[title] {
    border-bottom-style: none;
    text-decoration: none;
    /*text-decoration-line: underline;
    text-decoration-style: dotted;
    text-decoration-color: initial;*/
}

.message-only {
    margin-top: 60px;
    margin-bottom: 10px;
    font-size: 18px;
}
input.brfss-button {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 5px 15px 5px 15px !important;
    min-width: 80px;
    overflow: hidden;
    border: 1px solid #ccc;
    border-bottom-color: #b3b3b3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
        0 1px 2px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
        0 1px 2px rgba(0, 0, 0, 0.05);
    /* width: 50%; */
    -webkit-appearance: button;
    cursor: pointer;
    margin-bottom: 0;
    vertical-align: middle;
    display: inline-block;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
    padding: 0;
    margin: 0px 10px 10px 10px;
    flex-grow: 1;
}
input.brfss-button:disabled {
    border: none;
}

input.brfss-button.secondary {
    background: #84bc49;
    border-color: #84bc49;
    color: #333;
}

input.brfss-button.secondary:focus:enabled {
    background: #84bc49;
}

input.brfss-button.secondary:hover:enabled {
    background: #d7e3cc;
}
.show-on-2 {
    display: hidden;
}

@media only screen and (min-width: 1280px) {
}

@media only screen and (min-width: 992px) and (max-width: 1279px) {
    .show-on-4 {
        display: none;
    }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
    .show-on-3,
    .show-on-4 {
        display: none;
    }
}

@media only screen and (max-width: 767px) {
    .show-on-2,
    .show-on-3,
    .show-on-4 {
        display: none;
    }
}

.shaded-box {
    padding-top: 20px;
    background: #f0f0f0;
    border: 1px solid #e5e5e5;
    padding: 15px 15px 0 20px;
    margin-bottom: 15px;
    display: block;
    box-sizing: border-box;
}

.bread-crumbs a {
    text-emphasis: none;
    text-decoration-line: none;
    color: #075290;
}
h3 {
    font-size: 20px;
    font-weight: 400;
}
h3.user-msg {
    margin: 10px 0 10px 5px;
    /* background-color: #84bc49; */
    background-color: #70a33e; /* Need this for contrast */
    /* background-color: #075290 !important; */
    color: #ffffff !important;
    padding-top: 0.25em;
    padding-bottom: 0.25em;
    padding-left: 0.5em;
    padding-right: 0.5em;
}

.container {
    margin: auto;
    width: 100%;
}

@media (min-width: 768px) {
    .container {
        width: 99%;
    }
}
@media (min-width: 992px) {
    .container {
        width: 98%;
    }
}
@media (min-width: 1200px) {
    .container {
        /* width: 1185px; */
        width: 97%;
        /* max-width: 1620px; */
    }
    /* main {
    max-width: 1200px;
    margin: auto;
  } */
}

@media (min-width: 1400px) {
    .container {
        max-width: 1700px;
    }
}

.page-control,
.splash-description,
.the-header-container,
.selections,
.button-container,
.info-container,
.download-reset-buttons {
    max-width: 900px;
}

/* #weatForm {
  max-width: 900px;
} */

/* @media (min-width: 1400px) {
    .container {
        width: 100%;
        max-width: 1600px;
    }
} */

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.visually-hidden {
    border: 0;
    padding: 0;
    margin: 0;
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(
        1px 1px 1px 1px
    ); /* IE6, IE7 - a 0 height clip, off to the bottom right of the visible 1px box */
    clip: rect(
        1px,
        1px,
        1px,
        1px
    ); /*maybe deprecated but we need to support legacy browsers */
    clip-path: inset(
        50%
    ); /*modern browsers, clip-path works inwards from each corner*/
    white-space: nowrap; /* added line to stop words getting smushed together (as they go onto seperate lines and some screen readers do not understand line feeds as a space */
}

.tooltip-arrow {
    border: none;
}
.tooltip.in {
    opacity: 1;
}
.tooltip > .tooltip-inner {
    background: #d0e7b5;
    color: black;
    border: 1px solid #d0e7b5;

    padding: 5px;
    border-radius: 6px;
    box-shadow: 2px 4px lightgray;
}

/* .tooltip.fade.bs-tooltip-bottom.show {
    right: 0px;
} */

h2 {
    display: block;
    font-size: 22px;

    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: 400;
    color: black;
    background-color: inherit;
}
input.search-text-box {
    height: 30px;
    margin-bottom: 10px;
    width: 250px;
    box-shadow: 1px 2px lightgrey;
    border: 2px;
}

.vdp-datepicker input {
    height: 30px;
}

.splash-description {
    box-sizing: border-box;
    margin-bottom: 20px;
    padding-bottom: 10px;
    overflow: hidden;
}

.splash-description p {
    padding: 0 15px 0 15px;
    line-height: 25px;
    font-family: Lato, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
    color: #000;
    margin: 0 0 10px;
    min-height: 20px;
    padding: 19px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
}

@media (max-width: 1199px) {
    .leftnav-wrapper {
        display: none;
    }

    content-section {
        width: 100%;
    }
}

@media (min-width: 1200px) {
    .app-section {
        display: flex;
    }
    .leftnav-wrapper {
        flex: 0 1 325px;
        /* max-width: 25%; */
        padding-right: 15px;
        padding-left: 15px;
        display: block;
        /* flex-grow: 0;
        flex-shrink: 0;
        flex-basis: 200px;
        margin-right: 20px; */
        /* width: 60%; */
        /* max-width: 325px; */
    }
    .content-section {
        margin: 0 15px;
        flex: 0 1 100%;
        /* overflow: auto; */
    }
}
@media (min-width: 1200px) {
    /* .leftnav-wrapper {
    flex-basis: 200px;
  } */
    /* .content-section {
    width: 100%;
  } */
}

.info-container {
    overflow: auto;
    padding-bottom: 10px;
    margin-right: 10px;
    display: flex;

    /* display: grid;
  grid-auto-flow: column;
  gap: 5%; */
}

@media (max-width: 767px) {
    .desktop-table {
        display: none !important;
    }
}

@media (max-width: 1199px) {
    .content-section {
        margin: 0 10px;
    }

    .info-container {
        margin-right: 0;
    }
}

@media (min-width: 768px) {
    .mobile-table {
        display: none !important;
    }
}
.mobile-table {
    width: 100%;
}
/* Do we need this? */
#footer .container div#hhs {
    right: 40px;
}
</style>
